import { Component, inject, input, output } from '@angular/core';
import { Location, NgClass, NgOptimizedImage } from '@angular/common';
import { animate, style, transition, trigger } from '@angular/animations';
import { MatTooltipModule } from '@angular/material/tooltip';
import { Router, RouterLink } from '@angular/router';
import { MatIconModule } from '@angular/material/icon';
import { CamelCasePipe } from '../../pipes/camelCase.pipe';
import { TranslocoPipe } from '@jsverse/transloco';

@Component({
    selector: 'app-head-title-page',
    templateUrl: './head-title-page.component.html',
    styleUrls: ['./head-title-page.component.scss'],
    animations: [
        trigger('slideInOut', [
            transition(':enter', [
                style({ transform: 'translateY(-100%)' }),
                animate(
                    '300ms ease-out',
                    style({ transform: 'translateY(0%)' }),
                ),
            ]),
            transition(':leave', [
                animate(
                    '300ms ease-out',
                    style({ transform: 'translateY(-100%)' }),
                ),
            ]),
        ]),
    ],
    standalone: true,
    imports: [
        MatIconModule,
        NgClass,
        RouterLink,
        MatTooltipModule,
        CamelCasePipe,
        NgOptimizedImage,
        TranslocoPipe,
    ],
})
export class HeadTitlePageComponent {
    title = input<string>();
    back = input<boolean>();
    backTo = input<string>();
    infoText = input<string>();
    value = input<string>();
    capitalizeFirst = input<boolean>(false);
    translateValue = input<boolean>(false);
    onBack = output();

    // feedback
    feedback = input<boolean>(false);
    starAverage = input<number>(0);
    reviewsNumber = input<number>(0);
    goToFeedback = input<boolean>(false);

    showInfos = false;

    location = inject(Location);
    router = inject(Router);

    historyBack() {
        if (this.location.isCurrentPathEqualTo(this.backTo())) {
            this.onBack.emit();
            return;
        }
        if (this.backTo()) {
            this.router.navigate([this.backTo()]).then();
        } else {
            this.location.back();
        }
    }
}
